import { getUserListFetch } from '@/api/userbook'
import { ref, onBeforeMount } from 'vue'
export default function () {
  const userList = ref([])
  const getUserList = async () => {
    try {
      const { code, records } = await getUserListFetch()
      if (code === '0000') {
        userList.value =
          records?.map((item: { name: string; id: string | number }) => {
            return {
              label: item.name,
              value: item.id,
            }
          }) ?? []
      }
    } catch (error) {
      console.log(error)
    }
  }

  onBeforeMount(() => {
    getUserList()
  })

  return {
    userList,
  }
}
